import {ACTION_CODE} from './_actionCode';
import {DashboardService} from '../../../services';
import {ErrorModel, ResultModel} from '../../../models';
import {LoggerService} from '../../../services';
const FUNCTION_CODE = 'GET_ALL_ADMIN_DASHBOARD_GROSS_MARGIN';

export async function getGrossMargin(userData: Record<string, any>, params: string) {
    try {
        LoggerService.logInfo('Action - getGrossMargin - Start');

        const getGrossMargin = await DashboardService.AdminService.getGrossMargin(userData, params);

        LoggerService.logInfo('Action - getGrossMargin - End - Success');

        return ResultModel.newSuccessResult(getGrossMargin);
    }
    catch (error) {
        LoggerService.logInfo('Action - getGrossMargin - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
